<template>
  <div id="question-list-card">
    <ul class="scrollList" slot="list">
      <li v-for="(item) of incomingList" v-bind:key="item.QuestionnaireID">
        <div class="box-body clearfix van-hairline--bottom">
          <h3>{{item.QuestionnaireName}}</h3>
          <div @click="switchBtn(item.QuestionnaireID,item.PublishStauts)">
            <van-switch
              v-model="item.PublishStauts"
              active-color="#07c160"
              inactive-color="#fff"
              size="20px"
              ref="switch"
            />            
          </div>
        </div>
        <div class="box-footer">
          <div
            class="fl"
          >{{ new Date(item.StartTime.replace(/-/g, '/')).pattern('yyyy-MM-dd')}} 至 {{new Date(item.EndTime.replace(/-/g, '/')).pattern('yyyy-MM-dd')}}</div>
          <div class="fr">
            <span>已提交：{{item.CompleteCount}}份</span>
          </div>
          <div style="clear:both"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      
    };
  },
  props: {
    incomingList: {
      default: []
    }
  },
  created: function() {},
  mounted: function() {
    // console.log(this.incomingList);
  },
  methods: {
    async switchBtn(questionnaireid,PublishStauts){
      
      let res = await this.xyapi.post(
        this.$store.state.apiPath + `/api/Questionnaire/Publish?QuestionnaireID=${questionnaireid}&publishStatus=${PublishStauts}`
      );
      if (res&&res.success) {
        this.xy.msgSuc( "更新成功！");
      } else {
        this.xy.msgError( res&&res.msg || "更新失败");
      }
    }
  }
};
</script>
<style lang='less' >
#question-list-card{
  .van-switch, .van-switch__node{
    float: right;
  }
  .scrollList{
    margin-top: 16px;
  }
  .box-body {
    border-bottom-color: #eee;
    padding: 24px 20px;
  }
  h3{
    font-size: 32px;
  }
  .box-footer {
    clear: both;
    padding: 20px;
  }
  li{
    margin-top: 20px;
    background-color: #fff;
  }
}
</style>  

